import bulkComponentsUpdate from "./operations/bulkComponentsUpdate";
import bulkPriceDataUpdate from "./operations/bulkPriceDataUpdate";
import generateReports from "./operations/generateReports";

export default {
  namespaced: true,
  modules: {
    bulkPriceDataUpdate,
    generateReports,
    bulkComponentsUpdate,
  },
};
